<template>
  <div class="d-w100vw d-h100vh">
    <div class="d-ps-absolute d-all0 d-of-hidden gradient-container">
      <div class="gradient-title-area">
        <DialpadLogo class="logo-above" />
        <div class="gradient-container-wrapper">
          <BackgroundGradient />
        </div>
        <DialpadLogo class="logo-below logo-blended" />
        <DialpadLogo class="logo-below logo-overlay" />
      </div>

      <div
        ref="designText"
        class="d-ps-absolute d-l8 d-mln8 d-tt-uppercase d-fc-primary-inverted d-fw-medium design-team-name-left"
      >
        Design
      </div>
      <div
        ref="teamText"
        class="d-ps-absolute d-r8 d-tt-uppercase d-fc-primary-inverted d-fw-medium design-team-name-right"
      >
        Team
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import DialpadLogo from '@/components/DialpadLogo.vue';
import BackgroundGradient from '@/components/BackgroundGradient.vue';

// Template refs
const designText = ref<HTMLDivElement | null>(null);
const teamText = ref<HTMLDivElement | null>(null);

// Measure text width and set CSS variable
const measureTextWidth = () => {
  if (designText.value && teamText.value) {
    // Get the width of both text elements
    const designWidth = designText.value.offsetWidth;
    const teamWidth = teamText.value.offsetWidth;

    // Use the larger width to ensure both fit properly
    const maxWidth = Math.max(designWidth, teamWidth);

    // Set the CSS variable on the document root
    document.documentElement.style.setProperty('--team-name-width', `${maxWidth}px`);

    console.log('Text widths measured:', { designWidth, teamWidth, maxWidth });
  } else {
    console.log('Text elements not found, retrying...');
    // Retry after a short delay if elements aren't ready
    setTimeout(measureTextWidth, 100);
  }
};

onMounted(() => {
  // Try multiple times to ensure fonts are loaded and elements are rendered
  setTimeout(measureTextWidth, 0);
  setTimeout(measureTextWidth, 100);
  setTimeout(measureTextWidth, 500);
});
</script>

<style lang="less">
// POSITION LOGO
.logo-above,
.logo-below {
  --logo-width: 278px;
  --logo-height: 128px;

  position: absolute;
  top: calc(50% - (var(--logo-height) / 2));
  left: calc(50% - (var(--logo-width) / 2));
}

.logo-above {
  opacity: 0.7;
}

.logo-blended {
  mix-blend-mode: color-burn;
}
.logo-overlay {
  opacity: 0.2;
}
.design-team-name-left,
.design-team-name-right {
  font-size: var(--dtn-font-size-200);
  font-weight: var(--dt-font-weight-medium);
  letter-spacing: 1px;
  mix-blend-mode: luminosity;
  top: calc(50% - var(--team-name-width) / 2);
}
.design-team-name-left {
  rotate: -90deg;
}
.design-team-name-right {
  rotate: 90deg;
}

.gradient-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  transform: translateZ(0);
}
</style>
